import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-citation-link',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './citation-link.component.html',
  styleUrls: ['./citation-link.component.scss']
})
export class CitationLinkComponent {
  @Input() citationNumber!: number;
  @Input() tooltipText = '';
  @Input() isAvailable = true;
  @Output() citationClick = new EventEmitter<number>();

  onClick(): void {
    if (this.isAvailable) {
      this.citationClick.emit(this.citationNumber);
    }
  }

  getAriaLabel(): string {
    if (!this.isAvailable) {
      return `Citation ${this.citationNumber} - Source not available`;
    }
    return this.tooltipText
      ? `Citation ${this.citationNumber}: ${this.tooltipText}`
      : `Citation ${this.citationNumber}`;
  }
}
